export default __webpack_public_path__ + "static/media/Juliana Almeida_.1fc9189c.png";